import React, { useMemo } from 'react';

export const useParseHtmlStrong = (text: string): React.ReactNode => {
  return useMemo(() => {
    const regex = /(<strong>(.*?)<\/strong>)/gi;
    const parts = [];
    let lastIndex = 0;

    let match;
    while ((match = regex.exec(text)) !== null) {
      const [fullMatch, , strongText] = match;
      const index = match.index;

      if (lastIndex < index) {
        parts.push(text.substring(lastIndex, index));
      }

      parts.push(<strong key={index}>{strongText}</strong>);

      lastIndex = index + fullMatch.length;
    }

    if (lastIndex < text.length) {
      parts.push(text.substring(lastIndex));
    }

    return parts;
  }, [text]);
};
